import * as activity from "./activity";
import * as autoplay from "./autoplay";
import * as bet from "./bet";
import * as clock from "./clock";
import * as dialog from "./dialog";
import * as freeRounds from "./freeRounds";
import * as freeSpins from "./freeSpins";
import * as game from "./game";
import * as gameInformation from "./gameInformation";
import * as gameRound from "./gameRound";
import * as gameRules from "./gameRules";
import * as gameSettings from "./gameSettings";
import * as money from "./money";
import * as paytable from "./paytable";
import * as pluginMenu from "./pluginMenu";
import * as spin from "./spin";
import * as ticker from "./ticker";
import * as win from "./win";

export {
  activity,
  autoplay,
  bet,
  clock,
  dialog,
  freeRounds,
  freeSpins,
  game,
  gameInformation,
  gameRound,
  gameRules,
  gameSettings,
  money,
  paytable,
  pluginMenu,
  spin,
  ticker,
  win
};
